import { render, staticRenderFns } from "./TariffTypeSelect.vue?vue&type=template&id=3d48c0cc&scoped=true"
import script from "./TariffTypeSelect.vue?vue&type=script&lang=js"
export * from "./TariffTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./TariffTypeSelect.vue?vue&type=style&index=0&id=3d48c0cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d48c0cc",
  null
  
)

export default component.exports